import { useIntl } from 'react-intl';

import { Heading } from '@/components/Cms/Heading/Heading';
import type {
  ContentfulHeadingFragment,
  ContentfulPlaceholderServiceFragment,
} from '@/graphql/contentful/api';
import { useIsMdDown } from '@/hooks/useMedia';
import { commonMessages } from '@/messages/common';

import * as S from './PlaceholderPrint.styles';

export const PlaceholderPrint = (
  _props: ContentfulPlaceholderServiceFragment,
) => {
  const isHeading = !!_props.placeholderHeading;
  const { formatMessage } = useIntl();
  const isMobileView = useIsMdDown();
  const triggerPrint = () => {
    window.print();
  };
  const showHeading = isMobileView && isHeading;
  return (
    <S.Wrapper $isHeading={isHeading}>
      {showHeading && (
        <Heading
          Heading={_props.placeholderHeading as ContentfulHeadingFragment}
        ></Heading>
      )}
      <S.PrintBox onClick={triggerPrint} data-testid='printBox'>
        <S.PrintIcon data-testid='printIcon' />
        <S.PrintText>{formatMessage(commonMessages.printText)}</S.PrintText>
      </S.PrintBox>
    </S.Wrapper>
  );
};
